import Box from '@mui/material/Box';
import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';

export const Container = styled(Box)(({}) => ({
  'minHeight': '100vh',
  'display': 'flex',
  'backgroundColor': '#DEEFFB',
  'backgroundImage': 'url(/assets/svg/background-checkout.svg)',
  'backgroundSize': 'contain',
  'backgroundPosition': 'bottom',
  'backgroundRepeat': 'no-repeat',
  'overflow': 'auto',
  'paddingTop': 60,
  'paddingBottom': 60,
  '& .logo': {
    marginBottom: 20,
  },
}));

export const Card = styled(MuiCard)(({ theme }) => ({
  borderRadius: 20,
  boxShadow: '0px 5px 20px 0px rgba(163, 207, 237, 0.50)',
}));

export const Row = styled(Box)(({ theme }) => ({
  borderBottom: '1px solid',
  borderColor: theme.palette.divider,
  padding: 10,
  display: 'flex',
  justifyContent: 'space-between',
}));
